"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseProvider = void 0;
class BaseProvider {
    static get mountedDialogs() {
        if (!window.globalMountedDialogs) {
            window.globalMountedDialogs = {};
        }
        return window.globalMountedDialogs;
    }
}
exports.BaseProvider = BaseProvider;
